// extracted by mini-css-extract-plugin
module.exports = {"Paper":"FarmRow_Paper__30dz5","Hot":"FarmRow_Hot__3YqRB","HotAvault":"FarmRow_HotAvault__2_wZk"};